// The field maximums, in the ONE place both halves of the site can read them
// (CMSY-108).
//
// It lives under src/ because that is the only directory CRA will let the form
// import from, and `api/_limits.js` requires it from here. One file, so the
// number the browser stops you at and the number the server refuses you at
// cannot drift apart — which is the whole failure mode worth designing against:
// a UI that allows 5000 characters in front of a server that refuses at 3000 is
// a form that looks fine and then loses the applicant at Submit.
//
// CommonJS on purpose: webpack imports it happily, and the Vercel function
// needs `require`.
//
// The numbers are generous against MEASURED reality, not guessed. Across the 44
// real applications in the table on 2026-09-22: longest productType 84
// characters, otherKitchenReqs 169, otherApplianceReqs 79, otherSocials 7, and
// the largest whole payload 1,280 bytes. Every cap below is at least 18× the
// longest real answer, and the body cap is 25× the largest real payload.
module.exports = {
  firstName: 100,
  lastName: 100,
  email: 254, // RFC 5321 maximum for a full address
  phone: 40, // international, with separators and an extension
  company: 200,
  typeId: 60,
  facilityId: 60, // each element of facilityIds
  facilityIds: 25, // number of elements; there are 8 kitchens

  // The free-text answers. Uncapped until 2026-09-22, which made them the one
  // honest way for a REAL applicant to trip the 32KB body limit: measured, about
  // 1,400 words across the three textareas gets there, and the form had no
  // maxLength to stop anyone typing it. The refusal would have been a bare 413
  // naming no field, and the log row would have truncated the very text they
  // wrote. Capped per field so a refusal names the field, and capped in the form
  // so it is a stop the applicant can see rather than an error after Submit.
  productType: 3000, // ~500 words
  otherKitchenReqs: 3000,
  otherApplianceReqs: 3000,
  otherSocials: 500,
  instagram: 200,
  twitter: 200,
  linkedIn: 200,
  howDidYouHearOther: 500,
  hoursPerWeek: 60,
  startTime: 60,

  clientKey: 36, // belt and braces: already validated as a UUID
  posthogDeviceId: 100,
  attributionJson: 4000, // the serialised attribution object

  // Google's lead-form columns, for api/ads-lead.js
  leadId: 512,
  leadColumnValue: 1000,
  leadColumns: 50,

  BODY_BYTES: 32 * 1024,
};
